/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
export const getFirstBoardOfEachGroup = (boardsByGroups) => {
  let result = [];
  if (Array.isArray(boardsByGroups)) {
    if (boardsByGroups.length > 0) result = boardsByGroups;
    return result;
  }
  Object.entries(boardsByGroups).forEach(([_, value]) => {
    if (Array.isArray(value)) {
      // If value is an array, take its first item
      if (value.length > 0) result.push(value[0]);
    } else if (typeof value === 'object' && value !== null) {
      // Check if the first child is an object, else return its first child and stop
      const firstChild = Object.values(value)[0];
      if (typeof firstChild === 'object' && !Array.isArray(firstChild) && firstChild !== null) {
        // First child is an object, recurse
        const nested = getFirstBoardOfEachGroup(value);
        if (Array.isArray(nested)) result.push(...nested);
        else if (nested) result.push(nested);
      } else if (Array.isArray(firstChild)) {
        // First child is an array, take its first item
        if (firstChild.length > 0) result.push(firstChild[0]);
      } else if (firstChild) {
        // First child is a single item
        result.push(firstChild);
      }
    }
  });
  return result;
};

export const groupBoardsByGroupName = (boards) => {
  const groups = {};
  for (const key in boards) {
    const board = boards[key];
    const boardGroup = board.groupName;
    if (groups[boardGroup] === undefined) {
      groups[boardGroup] = [];
    }

    groups[boardGroup].push(board);
  }

  return groups;
};

export const groupBoardsByGroupPath = (boards, lvl = 0) => {
  function groupRecursive(items, level = 0) {
    const grouped = {};
    const groupKeyIndex = {}; // Track first appearance index

    items.forEach((item, idx) => {
      let groupKey;
      if (Array.isArray(item.groupPath) && item.groupPath.length > level) {
        groupKey = item.groupPath[level];
      } else {
        groupKey = item.id.toString();
      }
      // Prefix groupKey with first appearance index
      if (groupKeyIndex[groupKey] === undefined) {
        groupKeyIndex[groupKey] = idx;
      }
      const orderedKey = `${groupKeyIndex[groupKey]}__${groupKey}`;
      if (!grouped[orderedKey]) {
        grouped[orderedKey] = [];
      }
      grouped[orderedKey].push(item);
    });

    // Sort keys by prefix index
    const sortedKeys = Object.keys(grouped).sort((a, b) => {
      const aIdx = parseInt(a.split('__')[0], 10);
      const bIdx = parseInt(b.split('__')[0], 10);
      return aIdx - bIdx;
    });

    // Recursively group subgroups in sorted order
    const orderedGrouped = {};
    sortedKeys.forEach((k) => {
      const canGoDeeper = grouped[k].some(
        item => Array.isArray(item.groupPath) && item.groupPath.length > (level + 1),
      );
      if (canGoDeeper) {
        orderedGrouped[k] = groupRecursive(grouped[k], level + 1);
      } else {
        orderedGrouped[k] = grouped[k];
      }
    });

    // orderedGrouped.item_order = sortedKeys;
    return orderedGrouped;
  }
  return groupRecursive(boards, lvl);
};

export const getBoardsByGroupName = (groupName = '', boards) => {
  if (boards[groupName] && boards[groupName].length) {
    return boards[groupName];
  }

  return [];
};

export const filterBoardsBySeniority = ({
  type,
  boards,
  premium = true,
  disabled = true,
  hidden = false }) => {
  switch (type) {
    case 'machineLearning':
      return boards.filter((board) => board.type === 'machineLearning'
                && (hidden || board.show === 1)
                && (premium || !board.premium)
                && (disabled || board.enabled));
    case 'senior':
      return boards.filter((board) => board.type === 'senior'
                && (hidden || board.show === 1)
                && (premium || !board.premium)
                && (disabled || board.enabled));
    case 'junior':
      return boards.filter((board) => board.type === 'junior'
                && (hidden || board.show === 1)
                && (premium || !board.premium)
                && (disabled || board.enabled));
    case 'code':
      return boards.filter((board) => board.type === 'senior'
                && board.enabledForCode > 0
                && (hidden || board.show === 1)
                && (premium || !board.premium)
                && (disabled || board.enabled));
    case 'aula':
      return boards.filter((board) => (hidden || board.showOnAula === 1)
                && (disabled || board.enabled));
    case 'all':
      return boards.filter((board) => (hidden || board.show === 1)
                && (premium || !board.premium)
                && (disabled || board.enabled));
    default: return [];
  }
};

export const filtreBoardsByGroups = ({ type, boards }) => {
  const filtredBoards = filterBoardsBySeniority({ type, boards });
  const boardsGroupedByGroups = groupBoardsByGroupPath(filtredBoards);
  // console.log('==================boardsGroupedByGroups', boardsGroupedByGroups, getFirstBoardOfEachGroup(boardsGroupedByGroups));
  return getFirstBoardOfEachGroup(boardsGroupedByGroups);
};
